module.exports = __webpack_public_path__ + "media/images/flags/zw-ad4af813ae5392742a5fbefbb8a21d23.svg";